<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('main_info_eve') }}</h5>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('id') }}
						</label>
						{{ idNew }}
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('title') }}
						</label>
						<div class="col-7">
							{{ detailsData.name }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('lead_group') }}
						</label>
						<div class="col-7">
                                <span v-if="detailsData.contact_type"
                                      :class='`badge badge-sm badge-pill badge-${detailsData.contact_type.class}`'>
                                    {{ detailsData.contact_type.name }}
                                </span>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('years') }}
						</label>
						<div class="col-7">
							{{ detailsData.year_on }} <span v-if="detailsData.year_off">- {{ detailsData.year_off }}</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-5">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('cond') }}
						</label>
						<div class="col-7">
							{{ detailsData.cond }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('more_info_eve') }}</h5>
				</div>

				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('country_buy') }}
						</label>
						<div class="col-7">
							<span v-for="item in countryList" v-if="item.id == detailsData.country_buy">
      							{{ item.name }}
    						</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('date_buy') }}
						</label>
						<div class="col-7">
							{{ formatDateToLocal(detailsData.date_buy) }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price_s') }}
						</label>
						<div class="col-7">
							{{ detailsData.price_s }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('type_owners') }}
						</label>
						<div class="col-7">
							<span v-if="detailsData.type_owners == 1">{{ $t('type_owners_my') }}</span>
							<span v-if="detailsData.type_owners == 2">{{ $t('type_owners_rent') }}</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('country_made') }}
						</label>
						<div class="col-7">
						<span v-for="item in countryList" v-if="item.id == detailsData.country_made">
      							{{ item.name }}
    					</span>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('size') }}
						</label>
						<div class="col-7">
							{{ detailsData.size }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('material') }}
						</label>
						<div class="col-7">
							{{ detailsData.material }}
						</div>
					</div>
				</div>
				<div class="form-group mb-5">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('designer') }}
						</label>
						<div class="col-7">
							{{ detailsData.designer }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('teh_info_eve') }}</h5>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('storage') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.storage == 1 ">
								Склад
							</template>
							<template v-if="detailsData.storage == 2 ">
								<span v-for="item in organizationList" v-if="item.id == detailsData.org">
      								<a :href="'/crm/organizations/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-if="detailsData.storage == 3 ">
								<span v-for="item in peopleList" v-if="item.id == detailsData.who">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
						</div>
					</div>
				</div>
				<template v-if="detailsData.rest">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('rest') }}
						</label>
						<div class="col-7">
								<span v-for="item in peopleList" v-if="item.id == detailsData.rest">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
						</div>
					</div>
				</div>
				</template>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('owner') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.owner" class="d-flex align-items-center">
								<app-avatar :avatar-class="'avatars-w-30'"
								            :img="detailsData.owner.profile_picture ?
                                            urlGenerator(detailsData.owner.profile_picture.path) :
                                            detailsData.owner.profile_picture"
								            :title="detailsData.owner.full_name"
								            class="mr-2"
								/>
								<span>{{ detailsData.owner.full_name }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group mb-0">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('created_at') }}
						</label>
						<div class="col-7">
							{{formatDateToLocal(detailsData.created_at)}}
						</div>
					</div>
				</div>
				
							
			</div>

			<div v-show="!isDetailsActive">
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('main_info_eve') }}</h5>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('title') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.name"
							           :error-message="$errorMessage(errors, 'name')"
							           type="text"/>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('lead_group') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.contact_type_id"
							           :error-message="$errorMessage(errors, 'contact_type_id')"
							           :list="contentTypeList"
							           list-value-field='name'
							           type="select"/>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('years') }}</label>
						<div class="col-3">
							<app-input v-model="detailsData.year_on"
							           :error-message="$errorMessage(errors, 'year_on')"
										   :placeholder="$t('year_on')"
							           type="text"/>
						</div>
						<div class="col-1"></div>
						<div class="col-3">
							<app-input v-model="detailsData.year_off"
							           :error-message="$errorMessage(errors, 'year_off')"
										   :placeholder="$t('year_off')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-5">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('cond') }}</label>
						<div class="col-7">
						<app-input
                  type="select"
                  list-value-field="name"
                  :list="CondList"
                  :placeholder="$t('choose_cond')"
                  v-model="detailsData.cond"
                  :error-message="$errorMessage(errors, 'cond')"
              />
						
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('more_info_eve') }}</h5>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('country_buy') }}</label>
						<div class="col-7">
						<app-input
							type="search-select"
							list-value-field="name"
							:list="countryList"
							:placeholder="$t('choose_a_country')"
							v-model="detailsData.country_buy"
						/>
						
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_buy') }}</label>
						<div class="col-7">
							<app-input
                				v-model="detailsData.date_buy"
                				:placeholder="$t('choose_a_date')"
								:popover-position="'top-start'"
								type="date"
              				/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price_s') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.price_s"
							           :error-message="$errorMessage(errors, 'price_s')"
										    :placeholder="$t('enter_price_s')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('type_owners') }}</label>
						<div class="col-7">
						<app-input
                  type="select"
                  list-value-field="name"
                  :list="OwList"
                  :placeholder="$t('choose_type_owners')"
                  v-model="detailsData.type_owners"
                  :error-message="$errorMessage(errors, 'type_owners')"
              />
						
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('country_made') }}</label>
						<div class="col-7">
						<app-input
							type="search-select"
							list-value-field="name"
							:list="countryList"
							:placeholder="$t('choose_a_country')"
							v-model="detailsData.country_made"
						/>

						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('size') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.size"
							           :error-message="$errorMessage(errors, 'size')"
										   :placeholder="$t('enter_size')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('material') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.material"
							           :error-message="$errorMessage(errors, 'material')"
										   :placeholder="$t('enter_material')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-5">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('designer') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.designer"
							           :error-message="$errorMessage(errors, 'designer')"
										    :placeholder="$t('enter_designer')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<h5  class="card-title text-muted mb-0">{{ $t('teh_info_eve') }}</h5>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">

							
							<app-input
                  type="radio"
                  list-value-field="name"
                  :list="storageList"
                  v-model="detailsData.storage"
                  :error-message="$errorMessage(errors, 'storage')"
              />

					</div>
				</div>
				<template v-if="detailsData.storage == 2 ">
				<div class="form-group mb-3">
					<div class="form-row">

						
							<app-input v-model="detailsData.org"
							           :error-message="$errorMessage(errors, 'org')"
							           :list="organizationList"
							           list-value-field='name'
										    :placeholder="$t('choose_org')"
							           type="search-select"/>

					</div>
				</div>
				</template>
				<template v-if="detailsData.storage == 3 ">
				<div class="form-group mb-3">
					<div class="form-row">

							<app-input v-model="detailsData.who"
							           :error-message="$errorMessage(errors, 'who')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>

					</div>
				</div>
				</template>
				<div class="form-group mb-3">
					<div class="form-row">
					<label class="col-5 mb-0 d-flex align-items-center">{{ $t('rest') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.rest"
							           :error-message="$errorMessage(errors, 'rest')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				
										 

				<div class="form-group mb-0">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('owner') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.owner_id"
							           :error-message="$errorMessage(errors, 'owner_id')"
							           :list="ownerList"
							           list-value-field='full_name'
							           type="select"/>
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationEve",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			storageList: [
	  		 		{ id: "1", name: "Склад", },
				  	{ id: "2", name: "Организация", },
					{ id: "3", name: "Персона", },
	  		],
			countryList: [],
			CondList: [
	  		 	{ id: "1", name: "1",},
				{ id: "2", name: "2",},
				{ id: "3", name: "3",},
				{ id: "4", name: "4",},
				{ id: "5", name: "5",},
				{ id: "6", name: "6",},
				{ id: "7", name: "7",},
				{ id: "8", name: "8",},
				{ id: "9", name: "9",},
				{ id: "10", name: "10",},

	  		],
			OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
		contentTypeList() {
			return this.$store.getters.contentType
		},
		idNew() {
			return this.detailsData.id;

		},
		
		
		
		
		
		ownerList() {
			return this.$store.getters.getOwner
		},
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			
			this.formData.year_on = this.detailsData.year_on;
			this.formData.year_off = this.detailsData.year_off;
			this.formData.cond = this.detailsData.cond;
			this.formData.country_made = this.detailsData.country_made;
			this.formData.country_buy = this.detailsData.country_buy;
			this.formData.storage = this.detailsData.storage;
			this.formData.type_owners = this.detailsData.type_owners;
			
			this.formData.date_buy = this.detailsData.date_buy ? moment(this.detailsData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;

			
			this.formData.price_s = this.detailsData.price_s;
			this.formData.size = this.detailsData.size;
			this.formData.material = this.detailsData.material;
			this.formData.designer = this.detailsData.designer;
			this.formData.who = this.detailsData.who;
			this.formData.rest = this.detailsData.rest;
			this.formData.org = this.detailsData.org;
			
			
			this.formData.contact_type_id = this.detailsData.contact_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		this.$store.dispatch('contentType');
		this.$store.dispatch('getOwner');
		this.$store.dispatch('getPerson');
		this.$store.dispatch('getOrganization');
		this.getAllCountrys();
	},
}
</script>

